// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"387":"29b30beb","403":"9291b2aa","502":"3ebc46ec","578":"cfdca054","836":"9f5d69db","857":"690cb011","936":"98cf4d63"}[chunkId] + ".chunk.css";
};